import { render, staticRenderFns } from "./PriorityOrASAPEditModal.vue?vue&type=template&id=6b6441a0&"
import script from "./PriorityOrASAPEditModal.vue?vue&type=script&lang=js&"
export * from "./PriorityOrASAPEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports